import Request from './Request'

const OrbitAiAdminService = {
	async listForecastRuns(params = {}) {
		const response = await Request.get('/api/admin/orbit-ai/forecast-runs', params)
		return response?.data || []
	},

	async getForecastRunDetail(triggerRequestId) {
		return Request.get(`/api/admin/orbit-ai/forecast-runs/${encodeURIComponent(triggerRequestId)}`)
	},

	async resubmitForecastRun(triggerRequestId) {
		return Request.post(`/api/admin/orbit-ai/forecast-runs/${encodeURIComponent(triggerRequestId)}/resubmit`, {})
	},

	async retryForecastRunDag(triggerRequestId) {
		return Request.post(`/api/admin/orbit-ai/forecast-runs/${encodeURIComponent(triggerRequestId)}/retry-dag`, {})
	},

	async reconcileForecastRun(triggerRequestId) {
		return Request.post(`/api/admin/orbit-ai/forecast-runs/${encodeURIComponent(triggerRequestId)}/reconcile`, {})
	},

	async nuclearResetForecastRun(triggerRequestId) {
		return Request.post(`/api/admin/orbit-ai/forecast-runs/${encodeURIComponent(triggerRequestId)}/nuclear-reset`, {})
	},

	async getTokenUsage(params = {}) {
		return Request.get('/api/admin/orbit-ai/token-usage', params)
	},

	async getTokenUsageDrilldown(params = {}) {
		return Request.get('/api/admin/orbit-ai/token-usage/drilldown', params)
	},

	async getMaintenanceMessage() {
		return Request.get('/api/admin/orbit-ai/maintenance-message')
	},

	async updateMaintenanceMessage(payload = {}) {
		return Request.post('/api/admin/orbit-ai/maintenance-message', payload)
	},
}

export default OrbitAiAdminService

